module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "modal-box-wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closePopup($event)
      }
    }
  }, [(_vm.isOpen) ? _c('div', {
    staticClass: "modal-box"
  }, [_c('div', {
    staticClass: "modal-box--content"
  }, [_c('span', {
    staticClass: "modal-box--closing-button icon yule-icon-close-small",
    on: {
      "click": _vm.closePopup
    }
  }), _vm._v(" "), (_vm.item.business_card_image_url) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.item.business_card_image_url,
      "alt": "business card",
      "onerror": 'this.onerror=null; this.src=\'' + this.image + '\';'
    }
  })]) : _c('div', {
    staticClass: "no_image"
  }, [_c('img', {
    attrs: {
      "src": _vm.image,
      "alt": "no image associated"
    }
  })])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37189162","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/leads/BusinessCardPopup.vue
// module id = 1869
// module chunks = 0